import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Job} from '../../interface/job';
import {JobService} from '../../services/job.service';
import {delay} from 'rxjs/operators';
import {MatSnackBar} from "@angular/material/snack-bar";

export interface JobResultDialogData {
  jobId: string;
  showProgress: boolean;
  title: string;
  error?: string;
  asf360?: boolean;
}

@Component({
  selector: 'app-job-result-dialog',
  templateUrl: './job-result-dialog.component.html',
  styleUrls: ['./job-result-dialog.component.scss']
})
export class JobResultDialogComponent implements OnInit {

  job?: Job;
  jobId: string;
  showProgress: boolean;
  title?: string;
  error?: string;
  asf360: boolean;


  constructor(
    public dialogRef: MatDialogRef<JobResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: JobResultDialogData,
    private jobService: JobService,
    private snack: MatSnackBar,
  ) {
    this.jobId = data.jobId;
    this.showProgress = data.showProgress;
    this.title = data.title;
    this.error = data.error;
    this.asf360 = data.asf360 ?? false;

  }

  ngOnInit(): void {
    this.loadJob(true);
  }

  loadJob(first: boolean): void {
    if (!this.title){
      this.title = 'Przetwarzanie zapytania...';
    }
    if (!this.error){
      this.error = 'Wystąpił błąd: ';
    }
    this.jobService.getJob(this.jobId, this.asf360)
      .pipe(delay(first ? 0 : 2000))
      .subscribe((job: Job) => {
        if (!job.exitCode) {
          this.loadJob(false);
        }

        if (job.exitCode === 200 && job.fileLocation) {
          this.jobService.downloadFile(this.jobId, this.asf360);
          this.dialogRef.close(true);
        }

        if (job.exitCode === 200) {
          if (job.output) {
            this.snack.open(job.output, '', {duration: 4000});
          }
          this.dialogRef.close(true);
        }
        if (job.exitCode !== 200 && job.exitCode !== null) {
          this.dialogRef.disableClose = false;
        }
        if (job.exitCode === 405) {
          if (job.fileLocation) {
            this.jobService.downloadFile(this.jobId, this.asf360);
          }
          this.dialogRef.disableClose = false;
        }
        if (job.exitCode === 400) {
          this.snack.open(job.output, '', {duration: 4000});
          this.dialogRef.close(true);
        }

        this.job = job;
      });
  }

}
